<div class="title-box">
  <!-- Linha 1: breadcrumb / "onde estou" -->
  <div class="title-box__context">
    <span class="onde-estou">
      ONDE ESTOU:
      <span class="local">{{ local }}</span>
    </span>
  </div>
  <!-- Linha 2: ações (sempre abaixo do título), alinhadas à direita -->
  <div class="title-box__actions">
    <button
      *ngIf="mostrarBotaoVoltar"
      mat-stroked-button
      color="primary"
      type="button"
      (click)="onVoltar()"
    >
      <mat-icon>arrow_back</mat-icon>
      Voltar
    </button>
    <button
      *ngIf="mostrarBotaoFiltrar"
      mat-flat-button
      color="primary"
      type="button"
      (click)="onAlternarFiltro()"
    >
      <mat-icon>filter_list</mat-icon>
      Filtrar resultados
    </button>
    <ng-content></ng-content>
  </div>
</div>
